import styled from 'styled-components';

export const SectionWrapper = styled.div`
    display: flex;
    width: 410px;
    height: 520px;
    flex-direction: column;
    padding: 20px 10px;
    
`;

export const SectionImageWrapper = styled.div`
    display:flex;
    justify-content: center;
    margin: 0 0 50px 0;
`;

export const SectionHeader = styled.div`
    font-family: ${props => props.theme.fonts.black};
    font-size: 24px;
    text-align:center;
    margin: 0 80px 30px 80px;
`;

export const StyledSectionDescription = styled.div`
    margin: 0 50px;
    line-height: 22px;
    font-family: ${props => props.theme.fonts.light};
    font-size: 16px;
    text-align:center;
`;

export const SectionHeaderLogoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 44px 76px 26px 76px;
`;

export const SectionHeaderLogoText = styled.div`
    margin-bottom: 10px;
    font-family: ${props => props.theme.fonts.black};
    font-size: 12px;
    text-align:center;
    color: ${props => props.theme.colors.grayDark};
    text-transform: uppercase;
    line-height: 16px;
`;

export const SectionContainer = styled.div`
    background: linear-gradient( to top, ${props => props.theme.colors.backgroundBlueDark} 204px, ${props => props.theme.colors.white} 204px 356px );
    border-radius: 12px;
`;
